import React from 'react';
import { useRecoilState } from 'recoil';
import { manageStudentsAtomStudents } from '../atoms';
import TableNotFound from '@/presentation/components/table/table-not-found/table-not-found';
const DataNotFoundComp = () => {
    const [state, setState] = useRecoilState(manageStudentsAtomStudents);
    return (React.createElement(TableNotFound, { onClick: () => {
            setState(prev => {
                return Object.assign(Object.assign({}, prev), { filters: {
                        input: '',
                        deleted: false
                    }, dataNotFound: false });
            });
        }, term: state.filters.input !== '' ? state.filters.input : null }));
};
export default DataNotFoundComp;
